import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { FC, useState } from 'react';
import AvaSuburbSearch from './AvaSuburbSearch/AvaSuburbSearch';
import { Paper } from '@mui/material';
import { Liquor, Home, LocationCity, Language, ManageSearch, AddShoppingCart, Summarize } from '@mui/icons-material';
import AvaSuburbPriorities from './AvaSuburbPriorities/AvaSuburbPriorities';
import { useAppSelector } from '@hooks/redux-custom';
import AvaSuburbList from './AvaSuburbList/AvaSuburbList';
import AvaDepotHours from './AvaDepotHours/AvaDepotHours';
import AvaDepotClusteringScreen from './AvaDepotClusteringScreen/AvaDepotClusteringScreen';
import { AvaProductClusteringScreen } from './AvaProductClusteringScreen/AvaProductClusteringScreen';
import AvaRangingScreen from './AvaRanging/AvaRangingScreen';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Paper>{children}</Paper>}
    </div>
  );
}

const AvaPage: FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const activeUser = useAppSelector((state) => state.activeUser.value);
  const userAccessStatus = activeUser?.user?.roles.find((role: any) => role.moduleName === 'ava');
  const hasWriteAccess = userAccessStatus.role > 1;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      {hasWriteAccess && (
        <>
          <Tabs value={tabValue} onChange={handleChange} data-testid="ava-page-tabs">
            <Tab icon={<Summarize />} label="Ranging" />
            <Tab icon={<AddShoppingCart />} label="Product Clustering" />
            <Tab icon={<Liquor />} label="Store Clustering" />
            <Tab icon={<Home />} label="Depot Hours" />
            <Tab icon={<LocationCity />} label="Suburb Priorities" />
            <Tab icon={<Language />} label="Suburb List" />
            <Tab icon={<ManageSearch />} label="Search Products" />
          </Tabs>
          <TabPanel data-testid="ava-depot-clustering-screen-page" value={tabValue} index={0}>
            <AvaRangingScreen />
          </TabPanel>
          <TabPanel data-testid="ava-depot-clustering-screen-page" value={tabValue} index={1}>
            <AvaProductClusteringScreen />
          </TabPanel>
          <TabPanel data-testid="ava-depot-clustering-screen-page" value={tabValue} index={2}>
            <AvaDepotClusteringScreen />
          </TabPanel>
          <TabPanel data-testid="ava-depot-hours-page" value={tabValue} index={3}>
            <AvaDepotHours />
          </TabPanel>
          <TabPanel data-testid="ava-suburb-list-page" value={tabValue} index={4}>
            <AvaSuburbPriorities />
          </TabPanel>
          <TabPanel data-testid="ava-suburb-list-page" value={tabValue} index={5}>
            <AvaSuburbList />
          </TabPanel>
          <TabPanel data-testid="ava-suburb-search-page" value={tabValue} index={6}>
            <AvaSuburbSearch />
          </TabPanel>
        </>
      )}
    </>
  );
};

export default AvaPage;
